/**
 * @generated SignedSource<<86676f16c3071e11c881c67f3b5db3f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorHeaderFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorLessonTypeSelect_session">;
  readonly " $fragmentType": "InstructorHeaderFragment_session";
};
export type InstructorHeaderFragment_session$key = {
  readonly " $data"?: InstructorHeaderFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorHeaderFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorHeaderFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InstructorLessonTypeSelect_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "c3fc504f9971ea6f63e9996c8e6bf5d2";

export default node;
